import app from "firebase/app";
import "firebase/auth";
import firebase from "firebase/app";
import { captureException } from "./sentry";

const config = {
	apiKey: "AIzaSyAFnD3dL3GdGHGjeOl-KmRyhsNaW6UuFfE",
	// authDomain: "fixel-console.firebaseapp.com",
	authDomain: "auth.fixel.ai",
	// databaseURL: "https://fixel-console.firebaseio.com",
	projectId: "fixel-console",
	storageBucket: "fixel-console.appspot.com",
	messagingSenderId: "334843605615",
	appId: "1:334843605615:web:d4e9fb2a2cb368d200539a"
};

class Firebase {
	initialized;
	auth;
	constructor() {
		app.initializeApp(config);
		this.initialized = true;
		this.auth = app.auth();
	}
	isInitialized() {
		return new Promise((resolve) => {
			console.log("initializing Firebase user");
			this.auth.onAuthStateChanged(resolve);
		});
	}
	fbInitialized() {
		return this.initialized;
	}
	/**
	 *
	 * @param name
	 * @param email
	 * @param password
	 * @returns {Promise<firebase.User>}
	 */
	async register(name, email, password, onFail) {
		try {
			await this.auth.createUserWithEmailAndPassword(email, password);
			await this.auth.currentUser.updateProfile({
				displayName: name
			});
			const token = await this.auth.currentUser.getIdToken();
			sessionStorage.setItem("token", token);

			return this.auth.currentUser;
		} catch (error) {
			captureException(error, "log", { email, username: name }, { action: "register" }, { scope: "firebase.js" });
			onFail(error);
		}
	}
	/**
	 *
	 * @returns {Promise<firebase.auth.UserCredential>}
	 */
	signInWithGoogle = async (onFail) => {
		const provider = new firebase.auth.GoogleAuthProvider();
		const userInfo = await this.auth.signInWithPopup(provider);
		const token = userInfo.credential.idToken;
		sessionStorage.setItem("token", token);
		return userInfo;
	};
	/**
	 *
	 * @param event
	 * @param email
	 * @param password
	 * @param onFail
	 * @returns {Promise<void>}
	 */
	signInWithEmailAndPasswordHandler = async (event, email, password) => {
		event.preventDefault();
		return this.auth.signInWithEmailAndPassword(email, password);
	};

	refreshToken = async (onFail) => {
		let res;
		try {
			console.log("Refreshing token");
			res = await firebase.auth().currentUser.getIdToken(true);
		} catch (e) {
			console.error("An error has occurred while trying to refresh token");
			captureException(e, "info", { email: firebase.auth().currentUser.email }, { action: "refreshToken" }, { scope: "firebase" });
			onFail(e);
		}

		return res;
	};

	/**
	 *
	 * @param err
	 * @returns {string}
	 */
	handleError = (err) => {
		let error;
		switch (err.code) {
			case "auth/user-not-found":
				error = "User was not found";
				break;
			case "auth/wrong-password":
				error = "Wrong Password";
				break;
			default:
				error = "There was a problem signing you in";
		}

		captureException(error, "info", "unknown", { action: "signInWithGoogle" }, { scope: "firebase.js" });
		return error;
	};

	getCurrentUsername() {
		return this.auth.currentUser && this.auth.currentUser.displayName;
	}

	getCurrentUserMail() {
		return this.auth.currentUser.email;
	}

	/**
	 *
	 * @returns {Promise<string>}
	 */
	getUserToken = () => {
		return this.auth.currentUser.getIdToken();
	};

	getUser = () => {
		return this.auth.currentUser || null;
	};

	logout() {
		return this.auth.signOut();
	}

	deleteUser = async () => {
		const user = firebase.auth().currentUser;

		user?.delete()
			.then(() => {
				console.log("user was deleted from Firebase");
				sessionStorage.removeItem("token");
				return true;
			})
			.catch((e) => {
				console.log("There was a problem deleting the user from Firebase. error:", e.message || e);
				captureException(e, "info", { email: user.email, username: user.displayName }, { action: "deleteUser" }, { scope: "firebase.js" });
				return false;
			});
	};
}

export default new Firebase();
